import ScrollContainer from "react-indiana-drag-scroll";
import styled from "styled-components";

import { ReactComponent as PinLogo } from "assets/pinlogo.svg";
import { ReactComponent as TrashSvg } from "assets/trash-icon.svg";
import ColormapInterface from "shared-types/colormapinterface";
import { getSpacing } from "stylesheetB2b";

export const ScrollableContainer = styled(ScrollContainer)`
  flex: 1;
`;

export const StyledWaitingList = styled.div<{ colors: ColormapInterface }>`
  border-left: solid 1px ${({ colors }) => colors.homeBorder};
  display: flex;
  flex-direction: column;
  position: relative;
`;
StyledWaitingList.displayName = "StyledWaitingList";

export const TrashIconModal = styled(TrashSvg)`
  width: 0.6em;
  height: 0.6em;
  flex-shrink: 0;
  margin-right: 15px;
`;

export const SectionContent = styled.div`
  min-height: 0;
  flex: 1;
  overflow: auto;
  padding: ${getSpacing(0)} ${getSpacing(3)};
`;
SectionContent.displayName = "SectionContent";

export const StyledPinLogo = styled(PinLogo)`
  fill: currentColor; /* stylelint-disable-line */
  flex-shrink: 0;
  height: 0.675em;
  width: 0.675em;
  margin-right: 10px;
`;
